import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import userApi from "../../api/userCurrent";
import { useDispatch } from "../../redux/hooks";
import { setCurrentUser, setToken } from "../../redux/slices/auth/authSlice";

import useAuth from "./useAuth";

type AuthTokenRehydrateResult = {
    isHydrated: boolean;
    error: string | null;
};

const useAuthTokenRehydrate = (): AuthTokenRehydrateResult => {
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token") ?? "";
    const { currentUser } = useAuth();
    const [isHydrated, setIsHydrated] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let isCancelled = false;

        const fetch = async () => {
            setIsHydrated(false);
            setError(null);

            if (currentUser) {
                setIsHydrated(true);
                return;
            }

            try {
                const currentUserResponse =
                    await userApi.getCurrentUserWithToken(token);
                if (!isCancelled) {
                    dispatch(setCurrentUser(currentUserResponse));
                    dispatch(setToken(token));
                }
            } catch (e) {
                setError("Invalid link");
            }

            setIsHydrated(true);
        };

        fetch();

        return () => {
            isCancelled = true;
        };
    }, [currentUser, dispatch, token]);

    return { isHydrated, error };
};

export default useAuthTokenRehydrate;
